// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  margin-top: 10px;
}
:host > div {
  padding: 16px;
}

.videoWrapper {
  position: relative;
  padding-bottom: 61%; /* 640:390 */
  height: 0;
  display: block;
}

.videoWrapper::ng-deep iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.videoWrapper::ng-deep youtube-player-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}

.cookie-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: solid 1px #5c0a31;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/storyblok/components/storyblok-video/storyblok-video.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,kBAAA;EACA,mBAAA,EAAA,YAAA;EACA,SAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAAF","sourcesContent":[":host {\n  margin-top: 10px;\n\n  > div {\n    padding: 16px;\n  }\n}\n\n.videoWrapper {\n  position: relative;\n  padding-bottom: 61%; /* 640:390 */\n  height: 0;\n  display: block;\n}\n\n.videoWrapper::ng-deep iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.videoWrapper::ng-deep youtube-player-placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.cookie-error {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  border: solid 1px #5c0a31;\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
